import React, {FC} from 'react';

import {IFieldMeta} from 'entities/metadata';
import {TEntityValue} from 'modules/data';
import {normalizeBoolValue} from 'utils/common';

interface IBoolCellStringProps {
    field?: IFieldMeta;
    value?: TEntityValue;
}

export const BoolCellString: FC<IBoolCellStringProps> = ({field, value}: IBoolCellStringProps) => {
    const {booleanValues = []} = field || {};
    const normalizedValue = normalizeBoolValue(value);
    const index = +normalizedValue;
    switch (value) {
    case 'Y':
    case 'N':
        return (<span>{booleanValues[index]}</span>);
    default:
        return <span>{value}</span>;
    }
};
